module.exports = __webpack_public_path__ + "img/avatar_1.50a799b7.svg";